import React, { useRef, useEffect, useState, useLayoutEffect } from 'react';

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import moment from 'moment';

am4core.useTheme(am4themes_animated);

function DeviceIdelMovingTimeChart({ data: docs, assetData, idleFuelRate, standardFuelRate, selectedGroup, loading, ...props }) {

    const [data, setData] = useState([]);
    const [header, setHeader] = useState('--');
    const [fuelPrice, setFuelPrice] = useState(0);

    useEffect(() => {
        // console.log('Grp - ', selectedGroup);
        // console.log('load .. ', loading);
        if (docs && docs.length) {
            // console.log(`docs:: `, docs)
            // if (selectedGroup !== 'd') {
            //     const grpData = groupDataByInterval(docs, selectedGroup);
            //     console.log(grpData);
            //     setData(grpData)
            // }
            setData(docs)
        }
        // setData(docs)
    }, [docs, selectedGroup]);

    // useEffect(() => {
    //     console.log(standardFuelRate);
    // }, [standardFuelRate]);

    const chart = useRef(null);

    useLayoutEffect(() => {
        if (selectedGroup && assetData) {
            const title = selectedGroup === 'w' ? 'Weekly' : selectedGroup === 'm' ? 'Monthwise' : selectedGroup === 'y' ? 'Yearwise' : 'Daywise';
            setHeader(`${title} Idle Time for ${assetData.assetCode}`)
        }

    }, [selectedGroup, assetData]);

    useEffect(() => {
        if (assetData && assetData.assetModel && assetData.assetModel.fuelType
            && assetData.assetModel.fuelType.currentRate) {
            setFuelPrice(assetData.assetModel.fuelType.currentRate)
        }
    }, [assetData]);

    useLayoutEffect(() => {
        if (!loading && data && data.length) {

            let totalFuelQty = 0;
            let totalFuelCost = 0;
            let totalIdleTime = 0;
            data.forEach(d => {
                d.fuel_qty = Number((d.idle_time_min * (idleFuelRate / 60)).toFixed(2))
                d.fuel_cost = Number((d.fuel_qty * fuelPrice).toFixed(2))
                totalFuelQty += Number(d.fuel_qty)
                totalFuelCost += Number(d.fuel_cost)
                totalIdleTime += Number(d.idle_time_min)
            })

            // console.log(data);

            let x = am4core.create("idealTimeChart", am4charts.XYChart);
            x.hiddenState.properties.opacity = 0; // this creates initial fade-in

            // x.colors.step = 2;

            // am4core.addLicense("ch-custom-attribution");

            let title = x.titles.create();
            title.text = header || '';
            title.fontSize = 15;
            title.marginBottom = 18;

            // Export
            x.exporting.menu = new am4core.ExportMenu();
            x.exporting.filePrefix = "fuel_idle_time_data" + new Date().getTime();;

            x.paddingRight = 20;

            let dateAxis = x.xAxes.push(new am4charts.CategoryAxis());
            // dateAxis.title.text = "Date"
            dateAxis.dataFields.category = 'date';
            // dateAxis.renderer.labels.template.rotation = -90;
            dateAxis.title.text = selectedGroup === 'm' ? 'Month' : selectedGroup === 'w' ? 'Week' : selectedGroup === 'y' ? 'Year' : 'Date Range';

            let valueAxis = x.yAxes.push(new am4charts.ValueAxis());
            valueAxis.title.text = 'Time in minute'
            valueAxis.tooltip.disabled = true;

            let qtyAxis = x.yAxes.push(new am4charts.ValueAxis());
            // qtyAxis.renderer.grid.template.disabled = true;
            // qtyAxis.renderer.labels.template.disabled = true;
            qtyAxis.syncWithAxis = valueAxis;
            qtyAxis.renderer.opposite = true;
            qtyAxis.renderer.line.strokeOpacity = 1;
            qtyAxis.renderer.line.strokeWidth = 2;
            qtyAxis.title.text = 'Fuel Qty (ltrs)'


            let costAxis = x.yAxes.push(new am4charts.ValueAxis());
            // costAxis.renderer.grid.template.disabled = true;
            // costAxis.renderer.labels.template.disabled = true;
            costAxis.syncWithAxis = valueAxis;
            costAxis.renderer.opposite = true;
            costAxis.renderer.line.strokeOpacity = 1;
            costAxis.renderer.line.strokeWidth = 2;
            costAxis.renderer.line.stroke = am4core.color("#fdd400");
            costAxis.renderer.labels.template.fill = am4core.color("#fdd400");
            costAxis.title.text = 'Fuel Cost'


            let series2 = x.series.push(new am4charts.ColumnSeries());
            series2.dataFields.valueY = "idle_time_min";
            series2.dataFields.categoryX = "date";
            series2.clustered = false;
            // series2.columns.template.width = am4core.percent(50);
            series2.tooltipText = "Idle time in {dateX}: [bold]{valueY} minutes[/]";
            series2.name = 'Idle Time'
            series2.columns.template.strokeOpacity = 0;


            // Apply random color from predefined color set
            series2.columns.template.adapter.add("fill", function (fill, target) {
                return x.colors.getIndex(target.dataItem.index);
            });

            function adjustColumnWidth() {
                let totalColumns = data.length;
                let totalWidth = dateAxis.pixelWidth;

                // Adjust the width here. This is an example formula.
                // Adjust the formula as per your requirement.
                let columnWidth = Math.min(20, totalWidth / (totalColumns));

                series2.columns.template.width = am4core.percent(columnWidth);
                series2.columns.template.column.cornerRadiusTopLeft = am4core.percent(columnWidth * 2);
                series2.columns.template.column.cornerRadiusTopRight = am4core.percent(columnWidth * 2);

            }

            let bulletColumn = series2.bullets.push(new am4charts.LabelBullet())
            bulletColumn.interactionsEnabled = false
            bulletColumn.dy = 30;
            bulletColumn.label.text = '{valueY}'
            bulletColumn.label.fill = am4core.color('#ffffff')

            // Calculate total 
            // let totalIdleTiime = data.reduce((acc, item) => acc + item.idle_time_min, 0);

            // Set custom legend name with total value
            series2.legendSettings.labelText = `Idle Time (Total: ${totalIdleTime} min, ${idleFuelRate ? 'Idle Rate ' + idleFuelRate + ' ltrs/Hr' : ''})`;

            // Adjust column width initially and on data change
            adjustColumnWidth();
            x.events.on("datavalidated", adjustColumnWidth);

            // let totalFuelQty = 0;
            // let totalFuelCost = 0;
            // x.events.on("beforedatavalidated", function (ev) {
            //     x.data.forEach(item => {
            //         item.fuel_qty = Number(Number(Number(item.idle_time_min) * Number(idleFuelRate / 60)).toFixed(2))
            //         totalFuelQty += Number(Number(Number(item.idle_time_min) * Number(idleFuelRate / 60)).toFixed(2))
            //         item.fuel_cost = (Number(Number(Number(item.idle_time_min) * Number(idleFuelRate / 60)).toFixed(2)) * 95).toFixed(2)
            //         totalFuelCost += 11; //(Number(Number(Number(Number(item.idle_time_min) * Number(idleFuelRate / 60)).toFixed(2)) * 95).toFixed(2))
            //         console.log(totalFuelCost);
            //     });
            // });

            // line series for fule quantity based on Idle time
            let lineSeries = x.series.push(new am4charts.LineSeries());
            lineSeries.name = "Fuel Qty.";
            lineSeries.dataFields.valueY = "fuel_qty";
            lineSeries.dataFields.categoryX = "date";
            lineSeries.yAxis = qtyAxis;
            lineSeries.strokeWidth = 2;
            lineSeries.tensionX = 0.8;
            lineSeries.tooltipText = "[#333 font-size: 10px]{name} in {categoryX}:\n[/][#333 font-size: 15px]{valueY} ltrs[/]";
            lineSeries.legendSettings.labelText = `Fuel Qty. (Total: ${totalFuelQty.toFixed(2)} ltrs.)`;

            // Apply dynamic calculation for fuel cost
            // lineSeries.adapter.add("valueY", function (value, target) {
            //     console.log(target);
            //     return 10; // target.dataItem.dataContext.ideal_time_min ? Number(Number(Number(target.dataItem.dataContext.ideal_time_min) * Number(idleFuelRate / 60)).toFixed(2)) : 10;
            // });

            // Optional: Add bullets to line series
            let bullet = lineSeries.bullets.push(new am4charts.CircleBullet());
            bullet.circle.stroke = am4core.color("#fff");
            bullet.circle.strokeWidth = 2;
            bullet.tooltipText = "[#333 font-size: 11px]{name} in {categoryX}:\n[/][#333 font-size: 15px]{valueY} ltrs[/]"

            // // Create a range to show average fuel cost
            // // let range = qtyAxis.createSeriesRange(lineSeries);
            // // range.value = 5;
            // // range.endValue = 5;
            // // range.axisFill.fill = am4core.color("#FF0000");
            // // range.axisFill.fillOpacity = 0.2;
            // // range.label.text = `Avg Fuel Cost: ${5}`;
            // // range.label.align = "right";

            // if (idleFuelRate) {
            //     let averageGuide = qtyAxis.axisRanges.create();
            //     averageGuide.value = idleFuelRate;
            //     averageGuide.grid.stroke = am4core.color("#ccdd44");
            //     averageGuide.grid.strokeWidth = 1;
            //     averageGuide.grid.strokeOpacity = 0.7;
            //     // averageGuide.label.text = `Avg Fuel Cost: ${5}`;
            //     averageGuide.label.align = "right";
            //     averageGuide.label.verticalCenter = "bottom";
            // }

            let lineSeriesCost = x.series.push(new am4charts.LineSeries());
            lineSeriesCost.name = "Fuel Cost.";
            lineSeriesCost.dataFields.valueY = "fuel_cost";
            lineSeriesCost.dataFields.categoryX = "date";
            lineSeriesCost.yAxis = costAxis;
            lineSeriesCost.strokeWidth = 2;
            lineSeriesCost.tensionX = 0.8;
            lineSeriesCost.tooltipText = "[#333 font-size: 10px]{name} in {categoryX}:\n[/][#333 font-size: 15px]{valueY} Rs.[/]";
            lineSeriesCost.stroke = am4core.color("#fdd400");
            lineSeriesCost.legendSettings.labelText = `Fuel Cost (Total: ${totalFuelCost.toFixed(2)} at ${fuelPrice}/ltr)`;

            let bulletCost = lineSeriesCost.bullets.push(new am4charts.Bullet());
            let bulletCostRectangle = bulletCost.createChild(am4core.Rectangle);
            // bulletCost.circle.stroke = am4core.color("#fff");
            // bulletCost.circle.strokeWidth = 2;
            bulletCost.horizontalCenter = "middle";
            bulletCost.verticalCenter = "middle";
            bulletCost.width = 7;
            bulletCost.height = 7;
            bulletCostRectangle.width = 7;
            bulletCostRectangle.height = 7;
            bulletCost.tooltipText = "[#333 font-size: 11px]{name} in {categoryX}:\n[/][#333 font-size: 15px]{valueY} Rs.[/]"


            x.legend = new am4charts.Legend();

            // Add cursor
            x.cursor = new am4charts.XYCursor();
            x.cursor.fullWidthLineX = true;
            x.cursor.xAxis = dateAxis;
            x.cursor.lineX.strokeOpacity = 0;
            x.cursor.lineX.fill = am4core.color("#000");
            x.cursor.lineX.fillOpacity = 0.1;


            // Add scrollbar
            if (data && data.length > 25) {
                // let scrollbarX = new am4core.Scrollbar();
                let scrollbarX = new am4charts.XYChartScrollbar();
                // scrollbarX.marginBottom = 50;
                x.scrollbarX = scrollbarX;
            }
            x.cursor = new am4charts.XYCursor();
            x.data = data;
            chart.current = x;

            return () => {
                if (x)
                    x.dispose();
            };
        }
    }, [data, header]);

    useLayoutEffect(() => {
        if (chart && chart.current)
            chart.current.paddingRight = props.paddingRight;
    }, [props.paddingRight]);

    return <>{loading ? <div style={{ width: "100%", height: "500px", display: 'flex', alignItems: 'center', justifyContent: 'center' }} >Loading ...</div> : <div id="idealTimeChart" style={{ width: "100%", height: "500px" }} />}</>
}

export default DeviceIdelMovingTimeChart;